import {
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { DealerMediaResponse } from '../services/client.service';
import { VideoPlayerService } from '../services/video-player.service';
import { CommonModule, NgClass, NgIf } from '@angular/common';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VideoPlayerComponent } from '../video-player/video-player.component';
@Component({
  selector: 'app-media-carousel',
  templateUrl: './media-carousel.component.html',
  styleUrls: ['./media-carousel.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    TilesModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatExpansionModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
    VideoPlayerComponent,
  ],
})
export class MediaCarouselComponent {
  @Input() id!: string;
  @Input() media: any;
  isEventInProgress: boolean = false;
  @ViewChild('imageModal') imageModal: any;
  modalImageUrl: string | undefined;
  modalImageAlt: string | undefined;
  activeSlideIndex: number = 0;
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @Input() isWalkthroughEnabled: boolean | undefined = false;
  @Input() introOutroMediaData!: DealerMediaResponse;
  @ViewChildren(VideoPlayerComponent) videoPlayerComponents!: QueryList<VideoPlayerComponent>;

  constructor(
    private elementRef: ElementRef,
    private videoPlayerService: VideoPlayerService
  ) {}

onCarouselSwipe(direction: 'left' | 'right', i: any) {
  this.videoPlayerService.clearActivePlayer();
  if (this.isEventInProgress) {
    return;
  }
  this.isEventInProgress = true;
  this.resetAllVideoPlayers();
  setTimeout(() => {
    if (this.videoElement) {
      this.videoElement.nativeElement.pause();
    }
    this.isEventInProgress = false;

    const trackItemsSelector = this.isWalkthroughEnabled
      ? '.carousel-track-items'
      : '.carousel-track-items' + i;

    const indicatorsSelector = this.isWalkthroughEnabled
      ? '.indicators'
      : '.indicators' + i;

    const items = this.elementRef.nativeElement.querySelectorAll(trackItemsSelector);
    const indicators = this.elementRef.nativeElement.querySelectorAll(indicatorsSelector);

    const itemCount = items.length;

    if (direction === 'right') {
      this.activeSlideIndex = this.activeSlideIndex - 1;
      if (this.activeSlideIndex < 0) {
        this.activeSlideIndex = itemCount - 1;
      }
    } else if (direction === 'left') {
      this.activeSlideIndex = this.activeSlideIndex + 1;
      if (this.activeSlideIndex >= itemCount) {
        this.activeSlideIndex = 0;
      }
    }

    this.updateActiveSlideClass(items, indicators, this.activeSlideIndex, direction);
  }, 300);
}


  resetAllVideoPlayers(): void {
    if (this.videoPlayerComponents) {
      this.videoPlayerComponents.forEach(videoPlayer => {
        if (videoPlayer) {
          videoPlayer.resetVideoIndex(true);
        }
      });
    }
  }

  private updateActiveSlideClass(
    items: NodeListOf<HTMLElement>,
    indicators: NodeListOf<HTMLElement>,
    activeIndex: number,
    direction: 'left' | 'right'
  ) {
    items.forEach((item, index) => {
      if (direction === 'right') {
        item.classList.remove('image-slide');
        item.classList.add('reverse');
      } else {
        item.classList.remove('reverse');
        item.classList.add('image-slide');
      }
      if (index === activeIndex) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
    indicators.forEach((indicator, index) => {
      if (index === activeIndex) {
        indicator.classList.add('active');
      } else {
        indicator.classList.remove('active');
      }
    });
  }

  updateActiveSlideIndex(i: number) {
    this.activeSlideIndex = i;
  }

  openMediaModal(imageUrl: string, altText: string) {
    this.modalImageUrl = imageUrl;
    this.modalImageAlt = altText;
    this.imageModal.nativeElement.style.display = 'block';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:block');
  }

  closeMediaModal() {
    this.videoPlayerService.clearActivePlayer();
    this.imageModal.nativeElement.style.display = 'none';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:none');
  }

  isObjectEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 : true;
  }

onDotClick(index: number): void {
  if (this.isEventInProgress || index === this.activeSlideIndex) return;

  this.videoPlayerService.clearActivePlayer();
  this.resetAllVideoPlayers();

  const trackItemsSelector = this.isWalkthroughEnabled
    ? '.carousel-track-items'
    : '.carousel-track-items' + this.id;

  const indicatorsSelector = this.isWalkthroughEnabled
    ? '.indicators'
    : '.indicators' + this.id;

  const items = this.elementRef.nativeElement.querySelectorAll(trackItemsSelector);
  const indicators = this.elementRef.nativeElement.querySelectorAll(indicatorsSelector);

  const direction = index > this.activeSlideIndex ? 'left' : 'right';
  this.activeSlideIndex = index;

  this.updateActiveSlideClass(items, indicators, this.activeSlideIndex, direction);
}


}
